

<script>
import Vue from 'vue'
import Velocity from 'velocity-animate'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapSearchState, mapMutations: mapSearchMutations } = createNamespacedHelpers('search')
const { mapState: mapDataState, mapGetters: mapDataGetters } = createNamespacedHelpers('data')



export default {
  name: 'Export',

  data () {
    return {
     
      currentState:'rate',
      searchItem: {},
  
      importerData: {},
      exporterData: {},
    
      countrycode:27,
 
      isShowSearchMsg: true,
      changeTab: ''
    }
  },
  mounted () {
    
    this.onTabSwitch()
    this.$nextTick(() => {
      this.currentState = 'rate'
      if (!this._.isEmpty(this.getTopProduct()())) {
      
        this.initInputValue()
      }
      //  if (this.$route.params.hscode != 1) {
      //   this.$refs.pr.setDefaultValue({ id: this.$route.params.hscode });
      // }
      // if (this.$route.params.exporter != 1) {
      //   this.$refs.ex.setDefaultValue({
      //     id: this.$route.params.exporter,
      //     text: this.$route.query.text
      //   });
      // }

      this.$root.$on('QuickShowEvent', () => {
        this.currentState = 'rate'
        try {
          this.closeAllDropdown(!this.$data.$isIE)
        } catch (e) {}
      })
    
    })
  },


  methods: {
    ...mapDataGetters([
     
      'getTopProduct'
    ]),
    ...mapSearchMutations([
     
      'updateHistory'
    ]),
    searchHandleAfter () {
      if (!this.$refs.pr) return

     
      this.$refs.pr && this.$refs.pr.setValueFromDefaultPlaceholder()
      if (!this.$refs.pr.text) {
        this.$Message.warning({content: this.$t('query.message.product_empty'), closable: true})
        return
      }
      if (!this.$refs.pr.text) {
   
        this.$Message.warning({content: this.$t('query.message.product_error'), closable: true})
        return
      }
      this.updateHistory({
     
        products: this.$refs.pr.value
      })
      
    },
    valueSync () {
      this.$refs.ex.$el.style.display = 'block'
     
      this.$refs.ex.$el.style.width = '1%'
      this.$refs.ex.$el.style.opacity = 0

      this.$refs.pr.$el.style.width = '1%'
      this.$refs.pr.$el.style.opacity = 0
      Velocity(this.$refs.ex.$el, { width: '29%', opacity: 1 }, { duration: 250 })
    
      Velocity(this.$refs.pr.$el, { width: '42%', opacity: 1 }, { duration: 250, delay: 50 })
    },
    onTabSwitch () {
      if(this.changeTab !== this.currentQueryType) {
        let chana = {id: 27, text: '中国'}
        if (this.currentQueryType === 'import') {
           this.countrycode=27
          this.$refs.ex.isRead = false
        
        } else if (this.currentQueryType === 'export') {
        
          this.countrycode=this.$refs.ex.value.idexporter
         
          this.$refs.ex.isRead = true
          this.$refs.ex.setDefaultValue(chana)
        }

        this.best = {}
        this.ranks = []
        this.hsData = {}
        this.ftas = []
        this.importerData = {}
        this.exporterData = {}
      }
      this.changeTab = this.currentQueryType
    },
 
    initInputValue () {
      let exporterItem = this.getExporterById()(this.exporter)
      let impoterItem = this.getImporterById()(this.importer)
      let productItem = this.getProductByCode()(this.hscode)
      if (!this._.isEmpty(exporterItem) && !this._.isEmpty(impoterItem) && !this._.isEmpty(productItem)) {
        this.$refs.ex.setDefaultValue({id: exporterItem.id, text: exporterItem.name})

        this.$refs.pr.setDefaultValue({id: productItem.code, text: productItem.name})
        this.searchItem = {exporter: exporterItem, impoter: impoterItem, product: productItem}
      } else if (!this._.isEmpty(this.historyExportItem) && !this._.isEmpty(this.historyImportItem) && !this._.isEmpty(this.historyProductItem)) {
        // this.$refs.ex.setDefaultValue(this.historyExportItem[0])
        // this.$refs.im.setDefaultValue(this.historyImportItem[0])
        // this.$refs.pr.setDefaultValue(this.historyProductItem[0])
        // this.searchItem = {exporter: this.historyExportItem[0], impoter: this.historyImportItem[0], product: this.historyProductItem[0]}
      }
    },
    closeDowndown (isBlur, event) {
      if (isBlur && this.$refs.input) this.$refs.input.blur()
      this.isShowDropDown = false
      if (isBlur === undefined) {
        this.$emit('closeDropdown', event, 'ex')
      }
    },
  
  
    handleClick (event, componentName) {
      switch (componentName) {
        case 'exporter':

          this.$refs.pr.closeDowndown(false)
          break
        case 'importer':
          this.$refs.ex.closeDowndown(false)
          this.$refs.pr.closeDowndown(false)
          break
        case 'product':
          this.$refs.ex.closeDowndown(false)
         
          break
      }
    },
    enterEvent (event, componentName) {
    
      switch (componentName) {
        case 'ex':
          if (this.$refs.ex.text) {
            this.setAutomatic(componentName)
          }
          break
       
        case 'pr':
          if (this.$refs.pr.text) {
            this.setAutomatic(componentName)
          }
          break
      }
      setTimeout(() => {
        // if (this.$refs.ex.value.id && this.$refs.im.value.id && this.$refs.pr.value.id) {
        this.isShowSearchMsg = false
        this.searchHandle()
        // }
      }, 300)
    },
    escEvent (event) {
      if (event && event.keyCode === 27) {
        this.closeAllDropdown()
      }
    },
    tabEvent (event, componentName) {
      this.setAutomatic(componentName)
    },
    closeDropdown (event, componentName) {
      this.setAutomatic(componentName, false)
    },
    closeAllDropdown (isBlur = true) {
      this.$refs.ex.closeDowndown(isBlur)

      this.$refs.pr.closeDowndown(isBlur)
    },
    setAutomatic (componentName, isNextDropDown = true) {
      switch (componentName) {
        case 'ex':
          this.$refs.ex.closeDowndown(true)
          if (isNextDropDown || this.$refs.ex.text) {
            if (!this.$refs.pr.text) {
              this.$refs.pr.inputClick()
            }
          }
          break
     
        case 'pr':
          this.$refs.pr.closeDowndown(true)
          break
      }
    },
   
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/minxins.vue